import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, CalendarHolidays } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeCalendarHolidays(
    request: Boundaries["removeCalendarHolidays"]["request"],
  ): void;
}

function useRemoveCalendarHolidays(
  calendarHolidays: Identifiable<CalendarHolidays>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveCalendarHolidaysRequestPending(calendarHolidays),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveCalendarHolidaysRequestSuccess(calendarHolidays),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveCalendarHolidaysRequestFailure(calendarHolidays),
    ),
    removeCalendarHolidays: core.removeCalendarHolidays,
  };
}

export { useRemoveCalendarHolidays };
